/* Rôles Factumis — partagé entre l'écran Équipe et la page d'acceptation d'invitation.

   Quatre rôles organisationnels Better Auth (posés dans `role` du membership) :
   - admin        : tous droits, gère équipe et abonnement.
   - comptable    : lecture complète + exports. Aucune écriture.
   - commercial   : création et gestion de factures, devis et clients.
   - consultation : lecture seule.

   Le contrôle d'accès au niveau des actions est effectué côté serveur.
   Côté frontend, ces labels servent à l'affichage (invite, écran Équipe)
   et non à du gate-keeping UI (pas de vérification de rôle dans le rendu). */

export const ROLES = [
  { key: 'admin',        label: 'Administrateur', desc: 'Tous les droits, gère l’équipe et l’abonnement.' },
  { key: 'comptable',    label: 'Comptable',       desc: 'Lecture complète, exports et coffre. Aucune écriture.' },
  { key: 'commercial',   label: 'Commercial',      desc: 'Crée et gère factures, devis et clients.' },
  { key: 'consultation', label: 'Consultation',    desc: 'Lecture seule.' },
] as const;

export type RoleKey = (typeof ROLES)[number]['key'];

export const roleLabel = (k: string): string =>
  ROLES.find((r) => r.key === k)?.label ?? k;
